import { ok } from 'neverthrow';
import type {
  ActionResult,
  ApplicableContext,
  ExecuteContext,
} from '@cotera/client/v0/actions/framework';
import { WorkflowEditorToolbarActionBase } from './workflow-editor-toolbar-action.base';
import { workflowModelFromContext } from './workflow-toolbar-action.helpers';
import type { DraftConnectFrom } from './workflow-draft-graph';

export class WorkflowToolbarAddNodeAction extends WorkflowEditorToolbarActionBase {
  title = 'Add node';
  override description = 'Add a node to the workflow graph';
  group = 'Workflow';
  icon = 'plus';

  constructor(
    private readonly openAddNodeModal: (connectFrom?: DraftConnectFrom) => void
  ) {
    super();
  }

  override applicable(context: ApplicableContext): boolean {
    return workflowModelFromContext(context) !== null;
  }

  override async execute(
    _params: Record<string, never>,
    _context: ExecuteContext
  ): Promise<ActionResult<{ t: string }[]>> {
    this.openAddNodeModal();
    return ok({});
  }
}
